import React, { useState, useEffect, useRef } from "react";

import ChkBox from "components/Custom/ChkBox";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";

const dataJson = require("../gridData.json");

interface defaultProps {
  childRef: any;
  editRows: any[];
}

const Part4 = (props: defaultProps) => {
  const { childRef, editRows } = props;
  const [personalProtectCols, setPersonalProtectCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      sortable: true,
      width: "5%",
      className: "textCenter",
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);

  const tmpPersonalProtectRows = dataJson["7"]["7.1"];
  const tmpEquipmentRows = dataJson["8"]["8.1"];
  const tmpSubContractRows = dataJson["9"]["9.1"];
  for (let key in tmpPersonalProtectRows) {
    tmpPersonalProtectRows[key].comments = "";
    tmpPersonalProtectRows[key].checkBoxYes = "";
    tmpPersonalProtectRows[key].checkBoxNo = "";
  }
  for (let key in tmpEquipmentRows) {
    tmpEquipmentRows[key].comments = "";
    tmpEquipmentRows[key].checkBoxYes = "";
    tmpEquipmentRows[key].checkBoxNo = "";
  }
  for (let key in tmpSubContractRows) {
    tmpSubContractRows[key].comments = "";
    tmpSubContractRows[key].checkBoxYes = "";
    tmpSubContractRows[key].checkBoxNo = "";
  }

  const [personalProtectRows, setPersonalProtectRows] = useState<any[]>(
    tmpPersonalProtectRows
  );
  const [equipmentCols, setEquipmentCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ equipmentRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={equipmentRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...equipmentRows,
                  check: !equipmentRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ equipmentRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={equipmentRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...equipmentRows,
                  check: !equipmentRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);
  const [equipmentRows, setEquipmentRows] = useState<any[]>(tmpEquipmentRows);
  const [subConntractCols, setSubConntractCols] = useState<any[]>([
    {
      key: "question",
      name: "Question",
      type: "text",
      editable: false,
      width: "65%",
    },
    {
      key: "checkBoxYes",
      name: "YES",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ subConntractRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={subConntractRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...subConntractRows,
                  check: !subConntractRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "checkBoxNo",
      name: "NO",
      inputValue: "true",
      type: "radiobutton",
      className: "textCenter",
      sortable: true,
      width: "5%",
      renderCell: ({ subConntractRows, onRowChange, tabIndex }) => {
        return (
          <div className="excelChkWrapper">
            <ChkBox
              checked={subConntractRows.check}
              onChange={(val: any) => {
                onRowChange({
                  ...subConntractRows,
                  check: !subConntractRows.check,
                });
              }}
            />
          </div>
        );
      },
    },
    {
      key: "comments",
      name: "Comments",
      type: "text",
      editable: true,
      width: "25%",
    },
  ]);
  const [subConntractRows, setSubConntractRows] =
    useState<any[]>(tmpSubContractRows);

  const grid1Ref: any = useRef();
  const grid2Ref: any = useRef();
  const grid3Ref: any = useRef();

  useEffect(() => {
    childRef.saveRecord = saveRecord;
    return () => {
      childRef.saveRecord = null;
    };
  }, []);

  const saveRecord = () => {
    const section1 = grid1Ref.getRowData().map((s1) => {
      return {
        contractFormItemId: s1.contractFormItemId || -1,
        id: s1.id,
        Question: s1.Question,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        value: s1.value,
        comments: s1.comments,
      };
    });
    const section2 = grid2Ref.getRowData().map((s1) => {
      return {
        contractFormItemId: s1.contractFormItemId || -1,
        id: s1.id,
        Question: s1.Question,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        value: s1.value,
        comments: s1.comments,
      };
    });
    const section3 = grid3Ref.getRowData().map((s1) => {
      return {
        contractFormItemId: s1.contractFormItemId || -1,
        id: s1.id,
        Question: s1.Question,
        checkBoxYes: s1.checkBoxYes,
        checkBoxNo: s1.checkBoxNo,
        value: s1.value,
        comments: s1.comments,
      };
    });
    const items = [...section1, ...section2, ...section3];
    return { items };
  };

  return (
    <>
      <h4 className="ehsHeading1">{dataJson["7"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["7"]["heading2"]}</h5>
      {personalProtectRows ? (
        <ExcelGrid
          childRef={grid1Ref}
          cols={personalProtectCols}
          rows={personalProtectRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
      <h4 className="ehsHeading1">{dataJson["8"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["8"]["heading2"]}</h5>
      {equipmentRows ? (
        <ExcelGrid
          childRef={grid2Ref}
          cols={equipmentCols}
          rows={equipmentRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
      <h4 className="ehsHeading1">{dataJson["9"]["heading1"]}</h4>
      <h5 className="ehsHeading2">{dataJson["9"]["heading2"]}</h5>
      {subConntractRows ? (
        <ExcelGrid
          childRef={grid3Ref}
          cols={subConntractCols}
          rows={subConntractRows}
          noTotalRows={true}
        />
      ) : (
        <div className="pageCenter">
          <Loader />
        </div>
      )}
    </>
  );
};

export default Part4;
